import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EOtpremniceClient, TipPakovanjaDuvana } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-tip-pakovanja-duvana-dropdown',
  templateUrl: './tip-pakovanja-duvana-dropdown.component.html',
  styleUrls: ['./tip-pakovanja-duvana-dropdown.component.scss']
})
export class TipPakovanjaDuvanaDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';
  @Output() onItemChange = new EventEmitter<TipPakovanjaDuvana>();

  constructor(
    private _client : EOtpremniceClient,
  ) { }

  ngOnInit(): void {
    this._load();
  }

  private async _load() {
    this._subs.add(
      this._client.getTipPakovanjaDuvana().subscribe((res) => {
        this.items = res.data!.tipPakovanjaDuvanaList.map((x) => ({
          value: x.tip,
          label: x.tipStr,
          title: x.opis,
        }));
      })
    );
  }

  handleOnItemChange(event: any) {
    this.onItemChange.emit(event.value);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
